<template>
    <main>
        <div>
            <div class="card-header bg-light "><span><i class="fa fa-first-aid"> </i> Toma de Muestra</span> </div>
            <div class="mt-2" v-for="(tamizaje,i) in data" :key="i">
                <table class="table table-bordered table-sm">
                    <tr>
                        <th>Fecha de la Toma de muestra</th>
                        <td>{{tamizaje.fecha_lectura}}</td>
                    </tr>
                     <tr>
                        <th>No. Placa</th>
                        <td>{{tamizaje.numero_placa}}</td>
                    </tr>
                    <tr>
                        <th>Tipo Muestra</th>
                        <td>{{tamizaje.tipo_muestra}}</td>
                    </tr>
                    <tr class="bg-light">
                        <th>Tipo Tamizaje</th>
                        <td class="font-weight-bolder">{{tamizaje.tipo_tamizaje}}</td>
                    </tr>
                    <tr>
                        <th>Observaciones</th>
                        <td>{{tamizaje.observaciones}}</td>
                    </tr>
                    <tr>
                        <th>Aspectos del cuello</th>
                        <td>
                            <ul>
                                <li v-for="aspecto in tamizaje.aspectos" :key="aspecto.id">
                                    {{aspecto.aspecto}}
                                </li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </main>
</template>
<script>
export default {
    props:['idHistoria','idUsuario','finalizada','data'],
}
</script>
